import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "../../auth";
import { loadTeacherWorkload } from "../../services/teacherWorkloadService";

export default function Classes() {
  const user = getCurrentUser();
  const navigate = useNavigate();
  const campus = String(user?.campus || "gapan").toLowerCase();
  const [schoolYear, setSchoolYear] = useState("");
  const [classes, setClasses] = useState([]);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    (async () => {
      const res = await loadTeacherWorkload({ user, campus });
      const wl = res.data || {};
      setSchoolYear(res.schoolYear || "");
      setMeta(wl._meta || null);
      const cls = Array.isArray(wl.classes) ? wl.classes.filter(c =>
        String(c.grade || "").trim() || String(c.section || "").trim() || String(c.subject || "").trim() || String(c.gradebookUrl || "").trim()
      ) : [];
      setClasses(cls);
    })();
  }, [user?.uid, user?.email, campus]);

  const rows = useMemo(() => {
    return classes.map((c, idx) => ({
      idx,
      grade: String(c.grade || ""),
      section: String(c.section || ""),
      subject: String(c.subject || ""),
      schedule: String(c.schedule || ""),
      room: String(c.room || ""),
      gradebookUrl: String(c.gradebookUrl || c.gradebookLink || c.link || "")
    }));
  }, [classes]);

  return (
    <div className="container mt-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          <h3 className="mb-0">Class Program</h3>
          <div className="text-muted">{schoolYear ? `School Year: ${schoolYear}` : ""}</div>
          {meta?.source && <div className="text-muted small">Workload source: {meta.source}</div>}
          {meta?.source === "fallbackAdviserMap" && (
            <div className="text-muted small">
              UID: {meta?.uid || "—"} | Email: {meta?.email || "—"} | Campus: {meta?.campus || "—"}
            </div>
          )}
          {meta?.source === "fallbackAdviserMap" && meta?.attempted?.currentIds && (
            <div className="text-muted small">
              Tried current IDs: {Array.isArray(meta.attempted.currentIds) ? meta.attempted.currentIds.join(", ") : String(meta.attempted.currentIds)}
            </div>
          )}
          {meta?.source === "fallbackAdviserMap" && Array.isArray(meta?.errors) && meta.errors.length > 0 && (
            <div className="text-danger small">
              Load error: {meta.errors[0].code || ""} {meta.errors[0].message || ""}
            </div>
          )}
        </div>
      </div>

      <div className="card">
        <div className="table-responsive">
          <table className="table table-hover mb-0">
            <thead className="table-light">
              <tr>
                <th style={{ width: 160 }}>Grade</th>
                <th style={{ width: 160 }}>Section</th>
                <th>Subject</th>
                <th style={{ width: 220 }}>Schedule</th>
                <th style={{ width: 140 }}>Room</th>
                <th style={{ width: 260 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr><td colSpan="6" className="text-center text-muted py-4">No assigned classes yet</td></tr>
              ) : rows.map(r => (
                <tr key={r.idx}>
                  <td>{r.grade}</td>
                  <td>{r.section}</td>
                  <td>{r.subject}</td>
                  <td>{r.schedule}</td>
                  <td>{r.room}</td>
                  <td>
                    <div className="d-flex flex-wrap gap-2">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => navigate(`/teacher/class-list?campus=${encodeURIComponent(campus)}&grade=${encodeURIComponent(r.grade)}&section=${encodeURIComponent(r.section)}`)}
                        disabled={!r.grade || !r.section}
                      >
                        Class List
                      </button>
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => window.open(r.gradebookUrl, "_blank", "noopener,noreferrer")}
                        disabled={!r.gradebookUrl}
                      >
                        Gradebook
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
